import { CIMSSingleColumn } from 'components/CIMSTable/CIMSColumn/types'
import { IdentifiedFieldIssue } from '../../../IFITrackerContext/types'
import { List } from 'antd'
import { HelpMessage } from 'utils/constants'
import { getReport } from '../../../utils/getReport'

export function useSuggestedIssueType(): CIMSSingleColumn<IdentifiedFieldIssue> {
  return {
    title: 'Suggested Issue Types',
    render: ({ suggestedIssueTypes }) => {
      if (!suggestedIssueTypes.length) return null
      return (
        <List
          itemLayout="horizontal"
          size="small"
          split={false}
          dataSource={suggestedIssueTypes}
          renderItem={(item) => <List.Item>{item}</List.Item>}
        />
      )
    },
    width: 215,
    help: HelpMessage.IdentifiedFieldIssues.IFITracker.SuggestedIssueType,
    filter: {
      type: 'default',
      with: 'callback',
      items: (records) =>
        records.flatMap(({ suggestedIssueTypes }) => suggestedIssueTypes),
      onFilter: (value, record) => {
        const suggested = value as 'CDR' | 'NCR'
        const report = getReport(record)
        if (report?.__typename !== 'DailyInspectionInspection') return false // for now
        if (suggested === 'CDR') return report?.cdr === 'true'
        else if (suggested === 'NCR') return report?.ncr === 'true'
        return false
      },
    },
  }
}
